import { Injectable, Injector } from '@angular/core';
import { CrudService } from './crud.service';
import { AccessGroup } from '../models/rights/access-group';
import { Menu } from '../models/rights/menu';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AccessGroupsService extends CrudService<AccessGroup> {
    constructor(_injector: Injector) {
        super("accessgroups", _injector, AccessGroup);
    }

    getMenus(id: number): Observable<Menu[]> {
        let request: HttpRequest<any> = this.getRequest(this.baseUrl, "GET", id);
        request = request.clone({ url: request.url + '/menus' });

        return this.executeQuery<Menu[]>(request)
            .pipe(
                map(json => this.convertToT(Menu, json) as Menu[])
            );
    }

    setMenus(accessGroupId: number, menus: Menu[]): Observable<number[]> {
        let request: HttpRequest<any> = this.getRequest(this.baseUrl, "PATCH", accessGroupId, menus);
        request = request.clone({ url: request.url + '/menus' });

        return this.executeQuery<number[]>(request);
    }
}
